(function () {
  'use strict';

  const copy = {
    add: document.documentElement.lang.toLowerCase().startsWith('de') ? 'In den Warenkorb' : 'Add to cart',
    adding: document.documentElement.lang.toLowerCase().startsWith('de') ? 'Wird hinzugefügt …' : 'Adding …',
    soldOut: document.documentElement.lang.toLowerCase().startsWith('de') ? 'Ausverkauft' : 'Sold out',
    error: document.documentElement.lang.toLowerCase().startsWith('de')
      ? 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.'
      : 'This item could not be added. Please try again.',
  };

  const selectionState = {
    pendant: '',
    colour: '',
    size: '',
  };

  function parseItems(dialog, selector) {
    try {
      return JSON.parse(dialog.querySelector(selector)?.textContent || '{"items":[]}').items.filter(Boolean);
    } catch {
      return [];
    }
  }

  function normalizeColour(value) {
    const normalized = String(value || '').toLowerCase();
    if (normalized.includes('schwarz') || normalized.includes('black')) return 'black';
    if (normalized.includes('weiß') || normalized.includes('weiss') || normalized.includes('white')) return 'white';
    return normalized;
  }

  function activeDialog() {
    return document.querySelector('[data-cdu-dialog][open]');
  }

  function setSelected(buttons, selectedValue, attribute) {
    buttons.forEach((button) => {
      button.setAttribute('aria-checked', String(button.getAttribute(attribute) === selectedValue));
    });
  }

  function currentItem(dialog) {
    const type = dialog.dataset.cduType;
    if (type === 'pendant') {
      const items = parseItems(dialog, '[data-cdu-pendant-data]');
      return items.find((item) => item.key === dialog.dataset.cduPendant) || items.find((item) => item.available);
    }

    const colour = dialog.dataset.cduColour;
    const size = dialog.dataset.cduSize;
    return parseItems(dialog, '[data-cdu-refill-data]').find(
      (item) => normalizeColour(item.colour) === colour && String(item.size) === size
    );
  }

  function updateDialog(dialog) {
    const type = dialog.dataset.cduType;
    const pendantPanel = dialog.querySelector('[data-cdu-panel="pendant"]');
    const refillPanel = dialog.querySelector('[data-cdu-panel="refill"]');
    pendantPanel?.toggleAttribute('hidden', type !== 'pendant');
    refillPanel?.toggleAttribute('hidden', type !== 'refill');

    if (type === 'pendant') {
      const pendantButtons = [...dialog.querySelectorAll('[data-cdu-pendant-choice]')];
      setSelected(pendantButtons, dialog.dataset.cduPendant, 'data-cdu-pendant-choice');
    } else {
      if (dialog.dataset.cduColour === 'mix') {
        dialog.dataset.cduSize = '20';
        selectionState.size = '20';
      }
      const colourButtons = [...dialog.querySelectorAll('[data-cdu-colour-choice]')];
      const sizeButtons = [...dialog.querySelectorAll('[data-cdu-size-choice]')];
      setSelected(colourButtons, dialog.dataset.cduColour, 'data-cdu-colour-choice');
      setSelected(sizeButtons, dialog.dataset.cduSize, 'data-cdu-size-choice');
      sizeButtons.forEach((button) => {
        const unavailableForMix = dialog.dataset.cduColour === 'mix' && button.dataset.cduSizeChoice !== '20';
        button.disabled = unavailableForMix;
        button.setAttribute('aria-disabled', String(unavailableForMix));
      });
    }

    const item = currentItem(dialog);
    const image = dialog.querySelector('[data-cdu-image]');
    const addButton = dialog.querySelector('[data-cdu-add]');
    dialog.querySelector('[data-cdu-title]').textContent = item?.title || '';
    dialog.querySelector('[data-cdu-price]').textContent = item?.price || '';
    image.src = item?.image || '';
    image.toggleAttribute('hidden', !item?.image);
    addButton.dataset.variantId = item?.id || '';
    addButton.disabled = !item?.available;
    dialog.querySelector('[data-cdu-add-label]').textContent = item?.available ? copy.add : copy.soldOut;
  }

  function openDialog(type, trigger) {
    const dialog = document.querySelector('[data-cdu-dialog]');
    if (!dialog) return;

    dialog._cduTrigger = trigger;
    dialog.dataset.cduType = type;
    if (type === 'pendant') {
      const pendants = parseItems(dialog, '[data-cdu-pendant-data]');
      const selectedPendant = pendants.find(
        (item) => item.key === selectionState.pendant && item.available
      ) || pendants.find((item) => item.available);
      dialog.dataset.cduPendant = selectedPendant?.key || '';
      selectionState.pendant = dialog.dataset.cduPendant;
    } else {
      const refills = parseItems(dialog, '[data-cdu-refill-data]');
      const preferred =
        refills.find(
          (item) =>
            normalizeColour(item.colour) === selectionState.colour &&
            String(item.size) === selectionState.size &&
            item.available
        ) ||
        refills.find((item) => normalizeColour(item.colour) === 'black' && String(item.size) === '10') ||
        refills.find((item) => item.available);
      dialog.dataset.cduColour = normalizeColour(preferred?.colour || 'black');
      dialog.dataset.cduSize = String(preferred?.size || '10');
      selectionState.colour = dialog.dataset.cduColour;
      selectionState.size = dialog.dataset.cduSize;
    }

    dialog.querySelector('[data-cdu-error]').hidden = true;
    updateDialog(dialog);
    dialog.showModal();
  }

  async function addToCart(dialog, button) {
    const error = dialog.querySelector('[data-cdu-error]');
    const label = dialog.querySelector('[data-cdu-add-label]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    label.textContent = copy.adding;

    try {
      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const data = await response.json();
      if (!response.ok || data?.status) throw new Error(data?.description || data?.message || copy.error);

      dialog.close();
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (caught) {
      error.textContent = caught?.message || copy.error;
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = copy.add;
    }
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cdu-open]');
    if (openButton) {
      openDialog(openButton.dataset.cduOpen, openButton);
      return;
    }

    const dialog = activeDialog();
    if (!dialog) return;

    if (event.target.closest('[data-cdu-close]')) {
      dialog.close();
      return;
    }

    const pendantChoice = event.target.closest('[data-cdu-pendant-choice]');
    if (pendantChoice) {
      dialog.dataset.cduPendant = pendantChoice.dataset.cduPendantChoice;
      selectionState.pendant = dialog.dataset.cduPendant;
      updateDialog(dialog);
      return;
    }

    const colourChoice = event.target.closest('[data-cdu-colour-choice]');
    if (colourChoice) {
      dialog.dataset.cduColour = colourChoice.dataset.cduColourChoice;
      selectionState.colour = dialog.dataset.cduColour;
      updateDialog(dialog);
      return;
    }

    const sizeChoice = event.target.closest('[data-cdu-size-choice]');
    if (sizeChoice && !sizeChoice.disabled) {
      dialog.dataset.cduSize = sizeChoice.dataset.cduSizeChoice;
      selectionState.size = dialog.dataset.cduSize;
      updateDialog(dialog);
      return;
    }

    const addButton = event.target.closest('[data-cdu-add]');
    if (addButton && !addButton.disabled && addButton.dataset.variantId) addToCart(dialog, addButton);
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-cdu-dialog]')) return;
    event.target._cduTrigger?.focus();
  }, true);
})();
